exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".view-button{-ms-flex-pack:right;justify-content:right}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/update-status-popup/update-status-popup.component.css"],"names":[],"mappings":"AAAA,aACE,oBAAA,qBAAuB,CACxB","file":"update-status-popup.component.css","sourcesContent":[".view-button {\n  justify-content: right;\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/update-status-popup/update-status-popup.component.css
// module id = FA5L
// module chunks = 0